import { type SyntheticEvent } from 'react';
import { useTeamMembersContext } from '../../Context/TeamMembersContext';
import { MembershipStatus } from '@/Models/TeamMember';
import UIStrings from '@/Utils/UIStrings';

export interface MenuItemProps {
    label: string;
    onClick?: (e: SyntheticEvent) => void;
}

function createMenuItem(label: string): MenuItemProps {
    return {
        label,
    };
}

function useTeamMemberManagementMenuItems(status: MembershipStatus, id: string): Array<MenuItemProps> {
    const { openDialog, resendInvitation } = useTeamMembersContext();
    switch (status) {
        case 'Invited':
            return [
                {
                    ...createMenuItem(UIStrings.ResendInvitation),
                    onClick: async () => {
                        await resendInvitation(id);
                    },
                },
                {
                    ...createMenuItem(UIStrings.RevokeInvitation),
                    onClick: () => {
                        openDialog(id, 'RevokeInvitationConfirmation');
                    },
                },
            ];
        case 'Member':
            return [
                {
                    ...createMenuItem(UIStrings.RemoveAccess),
                    onClick: () => {
                        openDialog(id, 'RemoveAccessConfirmation');
                    },
                },
            ];
        case 'Expired':
            return [
                {
                    ...createMenuItem(UIStrings.RevokeInvitation),
                    onClick: async () => {
                        openDialog(id, 'RevokeInvitationConfirmation');
                    },
                },
            ];
        default:
            throw new Error(`Unknown status: ${status}`);
    }
}

export default useTeamMemberManagementMenuItems;
